module.exports = __webpack_public_path__ + "img/andrea-photo.ecf95d35.png";